<script>
    import AssetTypeEditHeader from '@/components/page-asset-type-edit/asset-type-edit/AssetTypeEditHeader.vue';
    import AssetTypeEditData from '@/components/page-asset-type-edit/asset-type-edit/AssetTypeEditData.vue';
    import AssetTypeEditImage from '@/components/page-asset-type-edit/asset-type-edit/AssetTypeEditImage.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_ASSET_TYPE_EDIT}
        },
        components: {
            AssetTypeEditHeader: AssetTypeEditHeader,
            AssetTypeEditData: AssetTypeEditData,
            AssetTypeEditImage: AssetTypeEditImage,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <AssetTypeEditHeader />
        <hr class="hr_light_98">
        <AssetTypeEditData />
        <hr class="hr_light_98">
        <AssetTypeEditImage />
    </div>
</template>